import { TextLink } from '@domgen/base-design-system-2.0/atoms/TextLink';
import { SlidingPanel } from '@domgen/base-design-system-2.0/molecules/SlidingPanel';
import { gaEvent } from '@domgen/shared/services/ga/ga';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { brandCode } from '../../constants/brandCode';
import {
  getModelNumberLocationOptions,
  modelNumberLocationContent,
  modelNumberLocationOptions,
} from '../../constants/modelNumberLocation';
import { useIsTenantFeatureEnabled } from '../../hooks';
import { useAppState } from '../../store/selectors/useAppState';
import { useUrlParams } from '../../store/selectors/useUrlParams';
import { getSystemCode } from '../../utils/getSystemCode';
import { formApplianceName } from '../../utils/store/formApplianceName';
import { formCategoryName } from '../../utils/store/formCategoryName';
import { ModelNumberLocation } from '../ModelNumberLocation/ModelNumberLocation';

const styles = {
  howToFindModel: 'text-center md:text-left',
};

export const ModelNumberLocationLink = () => {
  const [displaySideDraw, setDisplaySideDraw] = useState(false);

  const { t } = useTranslation('modelSerialLanding', {
    keyPrefix: 'modelNumberLocation',
  });

  const urlParams = useUrlParams();
  const { session } = useAppState();
  const systemCode = getSystemCode(urlParams?.rs);
  const applianceName = formApplianceName.get();
  const applianceCategory = formCategoryName.get();

  const isModelNumberLocationEnabled = useIsTenantFeatureEnabled('modelNumberLocation');

  const toggleFindModelNumberPanel = () => {
    setDisplaySideDraw((prev) => !prev);
    gaEvent({
      event: 'genericGAEvent',
      eventCategory: 'appliance details form USA',
      eventAction: displaySideDraw ? 'Close clicked' : 'CTA clicked',
      eventLabel: 'How to find your model number',
      pagename: 'olr-landing',
      category: 'registration-pages',
      type: 'STANDARD',
      regSystemCode: systemCode,
      applianceCategory: applianceCategory,
      applianceName: applianceName,
      appSessionID: session?.id,
    });
  };

  //Don't show text link slider if brand is not listed in allow list
  if (!isModelNumberLocationEnabled) return <></>;

  return (
    <>
      <div className={styles.howToFindModel}>
        <TextLink onClick={toggleFindModelNumberPanel}>{t('textLink')}</TextLink>
      </div>
      {modelNumberLocationContent && modelNumberLocationOptions && (
        <SlidingPanel
          isOpen={displaySideDraw}
          onClose={toggleFindModelNumberPanel}
          height="fit-content"
        >
          <ModelNumberLocation
            options={getModelNumberLocationOptions(brandCode)}
            content={modelNumberLocationContent}
            isOpen={displaySideDraw}
            handleClose={toggleFindModelNumberPanel}
          />
        </SlidingPanel>
      )}
    </>
  );
};
